import { useEffect, useRef } from 'react';

interface IMountedStatus{
    current: boolean;
}

/**
 * let subscribe to mount status
 */
const useMountStatus = () : IMountedStatus => {
    const componentRef = useRef(true);
    useEffect(() => {
        componentRef.current = true;
        return () => {
            componentRef.current = false;
        };
    });
    return componentRef;
};

export { useMountStatus };
